import type { App } from 'vue'

// 使用建置時注入的版本號（來自 VERSION 檔案或 package.json）
declare const __APP_VERSION__: string

export default {
  install(_app: App) {
    console.log(`== Application version: ${__APP_VERSION__} ==`)
  }
}
